export const SKELETON_ITEMS_LENGTH = 30;
